/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

/*
* Clean form fields
* WARNING! Object with form fields should be without nesting objects
* */

export default function resetForm (formFields: any) {
  Object.keys(formFields).forEach(function (key) {
    const type = typeof formFields[key]
    switch (type) {
      case 'string':
        formFields[key] = ''
        break
      case 'number':
        formFields[key] = 0
        break
      case 'boolean':
        formFields[key] = false
        break
      case 'object':
        if (Array.isArray(formFields[key])) {
          formFields[key] = []
        } else {
          formFields[key] = {}
        }
        break
      default:
        formFields[key] = ''
    }
  })
}
